import type { RootStore } from '@/store'
import type { StateCreator } from 'zustand'

/** Where the whitening kit ships. Kept on the device until the API carries an address. */
export type ShippingAddress = {
	line1: string
	line2?: string
	city: string
	state: string
	zip: string
}

export interface ProfileStore {
	shippingAddress?: ShippingAddress
	setShippingAddress: (value: ShippingAddress | undefined) => void
	/** Ask for Face ID (or Touch ID) every time the app comes to the front. */
	faceIdLock: boolean
	setFaceIdLock: (value: boolean) => void
}

export const createProfileSlice: StateCreator<RootStore, [], [], ProfileStore> = (
	set
) => ({
	shippingAddress: undefined,
	setShippingAddress: (value) => set({ shippingAddress: value }),
	faceIdLock: false,
	setFaceIdLock: (value) => set({ faceIdLock: value }),
})

export const profileStoreSelector = (state: RootStore) => ({
	shippingAddress: state.shippingAddress,
	setShippingAddress: state.setShippingAddress,
	faceIdLock: state.faceIdLock,
	setFaceIdLock: state.setFaceIdLock,
})

export const formatAddress = (address?: ShippingAddress) =>
	address
		? [address.line1, address.line2, `${address.city}, ${address.state} ${address.zip}`]
				.filter(Boolean)
				.join(', ')
		: undefined
